import { Box, CircularProgress } from '@mui/material';

type Props = {
  size?: string | number;
  color?: string;
  py?: number | string;
};

export const InlineLoader = ({ size = 20, color = 'inherit', py = 0.75 }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color,
        py,
      }}
    >
      <CircularProgress color="inherit" size={size} />
    </Box>
  );
};
